import React from "react";

import FAQ from "../../../../components/FAQ";
import UserEventsCardList from "./UserEventsCardList";
import Beneficios from "./Beneficios";

const components = {
    usereventscardlist: UserEventsCardList,
    faq: FAQ,
    beneficios: Beneficios,
};

const DynamicComponent = ({ name, state}) => {
  const Component = components[name?.toLowerCase().replace(/\s+/g, "")];
  return Component ? <Component state={state} /> : <></>;
};

export default DynamicComponent;